// Use the React shim to ensure consistent React instance
import { createRoot, React } from './lib/react-shim'
import App from './App.tsx'
import './index.css'

// Verify React is properly loaded
if (!React || !React.createElement) {
  console.error('React is not properly loaded. This might cause rendering issues.');
}

// Create root and render app
const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(React.createElement(App));
} else {
  console.error('Root element not found. Cannot mount application.');
}
